export default {
  info: 'engineeringModulesHeader.info',
  refresh: 'engineeringModulesHeader.refresh',
  print: 'engineeringModulesHeader.print',
  treeview: 'engineeringModulesHeader.treeview',
  wifi: 'engineeringModulesHeader.wifi',
  updateTitle: 'engineeringModulesHeader.updateTitle',
};
